.hero-section-component {
  min-height: 15rem;
  height: 45vh;
}
.hero-section-component.height-fit-content .section-content {
  height: 45vh;
  min-height: 15rem;
}
.hero-section-component.height-fit-content .section-content .column-component {
  height: 100%;
}
.hero-section-component.hidden {
  display: none;
}
.hero-section-component.align-height .section-content .column-component:last-child {
  height: 100%;
}
.hero-section-component.align-height .section-content .column-component:last-child .column-content {
  height: 100%;
}
.hero-section-component.align-height .section-content .column-component:last-child .column-content .panel-component.components-component-type .panel-header {
  margin: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9zcmMvc2NyaXB0L2NvbXBvbmVudHMvSGVyb1NlY3Rpb24iLCJzb3VyY2VzIjpbIkhlcm9TZWN0aW9uLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBOztBQUdFO0VBQ0U7RUFDQTs7QUFFQTtFQUNFOztBQUtOO0VBQ0U7O0FBS0U7RUFDRTs7QUFFQTtFQUNFOztBQUVBO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIuaGVyby1zZWN0aW9uLWNvbXBvbmVudCB7XG4gIG1pbi1oZWlnaHQ6IDE1cmVtO1xuICBoZWlnaHQ6IDQ1dmg7XG5cbiAgJi5oZWlnaHQtZml0LWNvbnRlbnQge1xuICAgIC5zZWN0aW9uLWNvbnRlbnQge1xuICAgICAgaGVpZ2h0OiA0NXZoO1xuICAgICAgbWluLWhlaWdodDogMTVyZW07XG5cbiAgICAgIC5jb2x1bW4tY29tcG9uZW50IHtcbiAgICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gICYuaGlkZGVuIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG5cbiAgJi5hbGlnbi1oZWlnaHQge1xuICAgIC5zZWN0aW9uLWNvbnRlbnQge1xuICAgICAgLmNvbHVtbi1jb21wb25lbnQ6bGFzdC1jaGlsZCB7XG4gICAgICAgIGhlaWdodDogMTAwJTtcblxuICAgICAgICAuY29sdW1uLWNvbnRlbnQge1xuICAgICAgICAgIGhlaWdodDogMTAwJTtcblxuICAgICAgICAgIC5wYW5lbC1jb21wb25lbnQuY29tcG9uZW50cy1jb21wb25lbnQtdHlwZSAucGFuZWwtaGVhZGVyIHtcbiAgICAgICAgICAgIG1hcmdpbjogMDtcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cbiJdfQ== */